import { api } from '../../http';
import {
  BulkDeletePreviewResponse,
  BulkDeleteCommitResponse,
  BulkUpdatePreviewResponse,
  BulkUpdateCommitResponse,
} from '../../types/bulkActions.types';

export const bulkActionsApi = {
  /** Upload CSV and get preview of user matches for bulk delete. */
  deleteUsersPreview: async (file: File): Promise<BulkDeletePreviewResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await api.post('/bulk-actions/users/delete/preview', formData);
    return data.result;
  },

  /** Commit the bulk delete operation for a given attempt. */
  deleteUsersCommit: async (attemptId: string, acknowledgedMismatches: boolean): Promise<BulkDeleteCommitResponse> => {
    const { data } = await api.post(`/bulk-actions/users/delete/${attemptId}/commit`, {
      acknowledgedMismatches,
    });
    return data.result;
  },

  /** Upload CSV and get preview of user matches for bulk update. */
  updateUsersPreview: async (file: File): Promise<BulkUpdatePreviewResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await api.post('/bulk-actions/users/update/preview', formData);
    return data.result;
  },

  /** Commit the bulk update operation for a given attempt. */
  updateUsersCommit: async (attemptId: string): Promise<BulkUpdateCommitResponse> => {
    const { data } = await api.post(`/bulk-actions/users/update/${attemptId}/commit`, {});
    return data.result;
  },

  /** Download the CSV report for a completed bulk action attempt. */
  downloadReport: async (attemptId: string): Promise<void> => {
    const { data } = await api.get(`/bulk-actions/${attemptId}/report`, {
      responseType: 'blob',
    });
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `bulk-action-report-${attemptId}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  },
};
